// --------------- Start : Kategoriefilter einblenden above the fold ---------------

document.addEventListener('click', (event) => {
  const label = event.target.closest('.filter-form__label');
  if (!label) return;

  const parent = label.closest('.filter-form__item');

  document.querySelectorAll('.filter-form__item')
    .forEach(item => item !== parent && item.classList.remove('form-item-open'));

  parent.classList.toggle('form-item-open');
});

document.addEventListener('DOMContentLoaded', () => {

    const toggletarget = document.querySelector('.filter-b-toggle');
    const stickyToggle = document.querySelector('.filter-sticky-toggle');

    if (toggletarget || stickyToggle){
        const toggleObserver = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              stickyToggle.classList.remove('active_toggle');
            } else {
              stickyToggle.classList.add('active_toggle');
            }
          },
          {
            root: null,
            threshold: 0
          }
        );

      if (window.innerWidth <= 768) {
        toggleObserver.observe(toggletarget);
      }
    }

  document.addEventListener('change', (event) => {
    const filter_item = event.target.closest('.filter-chip__input');
    const price_range_min = event.target.closest('.filter-form--version-b .price-range__input-min');
    const price_range_max = event.target.closest('.filter-form--version-b .price-range__input-max');
    
    if(filter_item){
      const data_filter_value = filter_item.value;
      document.querySelector(`.tag__input[value="${data_filter_value}"]`).click(); 
    }

    if (price_range_min) {
      const data_value = price_range_min.value;
      const input = document.querySelector('#FilterDrawer .price-range__input-min');
      if (input) {
        input.value = data_value;
        console.log(input.value);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (price_range_max) {
      const data_value = price_range_max.value;
      const input = document.querySelector('#FilterDrawer .price-range__input-max');
      if (input) {
        input.value = data_value;
        console.log(input.value);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

  });

});
// --------------- End : Kategoriefilter einblenden above the fold ---------------

document.addEventListener('DOMContentLoaded', function() {
  
    function checkForElement() {
      
        const element = document.querySelector('div[data-testid="minimized-trustbadge-floating"]');
        
        if (element) {
         
            const grandparent = element.parentElement?.parentElement;
            
        
            if (grandparent) {
                grandparent.style.zIndex = '20';
            }
            
            clearInterval(intervalId);
        }
    }

    const intervalId = setInterval(checkForElement, 100);

    setTimeout(function() {
      clearInterval(intervalId);
    }, 120000);

    const scrollThreshold = parseInt(document.body.getAttribute('show_widget'), 10) || 0;
    const hiddenElement = document.querySelector('.wa__widget_container');

    if (hiddenElement) {
      window.addEventListener('scroll', function () {
        if (window.scrollY > scrollThreshold) {
          hiddenElement.style.display = 'block';
        } else {
          hiddenElement.style.display = 'none';
        }
      });
    }
    // window.addEventListener('scroll', function() {
    //   const scrollThreshold = parseInt(document.body.getAttribute('show_widget'));
    //   const hiddenElement = document.querySelector('.wa__widget_container');
    
    //     if (window.scrollY > scrollThreshold) {
    //         hiddenElement.style.display = 'block'; // or use hiddenElement.classList.add('visible') if you have a CSS class for it
    //     } else {
    //         hiddenElement.style.display = 'none'; // or use hiddenElement.classList.remove('visible') if you have a CSS class for it
    //     }
    // });
  
});

const reviewObserver = new MutationObserver(() => {
  const button = document.querySelector("#ReviewsWidget .R-Button.R-Button--md.R-Button--primary.u-marginBottom--none.u-marginTop--md");
  
  if (button) {
    button.textContent = "Schreibe eine Bewertung";
    reviewObserver.disconnect();
    clearTimeout(timeoutId);
  }
});

document.addEventListener("DOMContentLoaded", function() {
  const reviewsWidget = document.querySelector("#ReviewsWidget");
  if (reviewsWidget) {
    reviewObserver.observe(reviewsWidget, { childList: true, subtree: true });
  } else {
    reviewObserver.observe(document.body, { childList: true, subtree: true });
  }
});

const timeoutId = setTimeout(() => {
  reviewObserver.disconnect();
  console.log("Stopped observing - Review.io empty review element not found within the time limit.");
}, 5000);

// 27/01/26H  PDP: BuyBox strukturieren und optimieren - Schritt 2
document.addEventListener('DOMContentLoaded', function () {
  var div = document.querySelector(".product-section");
  div?.classList.add("product-section-var-b");
  var body = document.querySelector("body");
  body.classList.add("product-section-var-b");
  
  var meta = document.querySelector('.product-single__meta');
  if (!meta) return;

  // Create wrapper if not exists
  var wrapper = meta.querySelector('.review_with_sku');
  if (!wrapper) {
    wrapper = document.createElement('div');
    wrapper.className = 'review_with_sku';
    meta.prepend(wrapper);
  }

  function moveElements() {
    var review = document.querySelector('reviewsio-product-ratings');
    var sku = meta.querySelector('.product-single__sku');

    if (review && !wrapper.contains(review)) wrapper.appendChild(review);
    if (sku && !wrapper.contains(sku)) wrapper.appendChild(sku);
  }

  // Try immediately after DOM is ready
  moveElements();

  // Keep watching because Reviews.io loads later
  var observer_old = new MutationObserver(function () {
    moveElements();

    var review = document.querySelector('reviewsio-product-ratings');
    var sku = meta.querySelector('.product-single__sku');

    if (review && sku && wrapper.contains(review) && wrapper.contains(sku)) {
      observer_old.disconnect();
    }
  });


  observer_old.observe(document.body, { childList: true, subtree: true });
});
